<template>
    <v-dialog
        v-model="$store.state.concil.matchedDataPanel"
        transition="dialog-bottom-transition"
        persistent
        width="1800"
        fullscreen
    >
        <v-container fluid style="padding: 0;overflow: hidden;">
            <v-card>
                <v-toolbar dark color="secondary" dense style="margin-bottom: 15px;">
                    <v-btn
                        icon
                        dark
                        @click="getReport('xlsx')"
                    >
                        <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        Matched Data Panel
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="$store.state.concil.matchedDataPanel = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-row style="padding: 20px 50px 30px;">
                    <v-col cols="12">
                        <v-card style="padding-top: 10px;" v-if="render">
                            <v-card-title style="padding-top: 20px;padding-bottom: 30px;">
                                Matched and Unmatched BOLs
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="dataSearch"
                                    append-icon="mdi-magnify"
                                    label="Search here"
                                    hide-details
                                    style="padding-top: 0;margin-top: 0;"
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                :headers="fmtMatchedData.Data.Headers"
                                :items="fmtMatchedData.Data.Main"
                                dense
                                height="800"
                                fixed-header
                                :search="dataSearch"
                                :item-class="itemRowBackground"
                            >
                                <template slot="body.append">
                                    <tr>
                                        <td
                                            v-for="(hd, idx) in fmtMatchedData.Data.ExcelHeaders"
                                            :key="idx"
                                        >
                                            <strong 
                                                v-if="fmtMatchedData.Data.Totals[0][hd] !== undefined && fmtMatchedData.Data.Totals[0][hd] !== '$NaN'"
                                                class="text-left font-weight-bold"
                                            >
                                                {{ fmtMatchedData.Data.Totals[0][hd] }}
                                            </strong>
                                            <strong
                                                v-else
                                                class="text-left font-weight-bold"
                                            ></strong>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:item.BillOfLading="{ item }">
                                    <td>
                                        <v-btn color="primary" dark small @click="openBOLDetails(item)">
                                            {{ item.BillOfLading }}
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>

        <ConcilBOLDetails
            v-if="$store.state.concil.bolDetails"
            :DataBOLDetails="dataBOLDetails"
            @close="onConcilBOLDetailsClose"
            :CallUpdate="true"
        ></ConcilBOLDetails>
    </v-dialog>
</template>

<script>
import axios from "axios";
//import * as XLSX from 'xlsx';
import ConcilBOLDetails from "./ConcilBOLDetails.vue";

export default {
    props: ['MatchedData'],
    components: {
        ConcilBOLDetails
    },
    data: function () {
        return {
            dataSearch: '',
            filename: '',
            render: false,
            fmtMatchedData: {},
            dataBOLDetails: null,
        }
    },
    mounted() {
        this.prepareData();
    },
    methods: {
        openBOLDetails: async function(item) {
            let str = this.$store;
            str.state.isLoading = true;
            let params = {
                Customer: this.MatchedData.Params.Customer,
                BOL: item.BillOfLading,
                DeliveryDate: item.DateDelivered,
            };

            console.log(params);
            await axios
                .post('conciliation/get/bol-details', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.dataBOLDetails = {
                        Data: response.data,
                        Params: params,
                    };
                    str.state.isLoading = false;
                    str.state.concil.bolDetails = true;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        prepareData: function () {
            console.log(this.MatchedData.Data);
            this.formatData();
        },
        formatData: function () {
            this.fmtMatchedData = JSON.parse(JSON.stringify(this.MatchedData));
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD',
            });

            this.fmtMatchedData.Data.Main.forEach(row => {
                this.fmtMatchedData.Data.CurrencyFormat.forEach(fmt => {
                    row[fmt] = cad.format(row[fmt]);
                });
            });

            this.fmtMatchedData.Data.Totals.forEach(row => {
                this.fmtMatchedData.Data.CurrencyFormat.forEach(fmt => {
                    row[fmt] = cad.format(row[fmt]);
                });
            });

            console.log(this.fmtMatchedData);
            this.render = true;
        },
        setParams: function (requestType) {
            this.filename = "Rec_" + this.MatchedData.Params.Customer.Alias + "_By_Invoice_" + this.MatchedData.Params.Invoice.InvId + "." + requestType;

            let params = {
                Customer: this.MatchedData.Params.Customer,
                Data: this.MatchedData.Data,
                Headers: this.MatchedData.Data.ExcelHeaders,
                Filename: this.filename,
                Report: {
                    Name: 'Reconciliation',
                    Alias: 'Reconciliation',
                    Value: 0,
                }
            };

            console.log(params);
            return params;
        },
        getReport: async function (requestType) {
            let str = this.$store;
            str.state.isLoading = true;
            let params = this.setParams(requestType);
            await axios
                .post('conciliation/get/report/' + requestType, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob',
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        onConcilBOLDetailsClose: function (updatePending) {
            if (updatePending) {
                console.log('Update pending');
                this.$emit('close');
                this.$store.state.concil.matchedDataPanel = false;
            } else {
                console.log("No update");
            }
        },
        itemRowBackground: function (item) {
            return item.IsMatched ? 'is-matched' : 'is-not-matched';
        },
    },
};
</script>

<style>
    .is-matched {
        background-color: #ABEBC6!important;
    }
    .is-not-matched {
        background-color: #F5B7B1!important;
    }
</style>